import type { WhatsAppMessage } from "../../../services/api";

export interface ParsedAgentPrefix {
  agentLabel: string | null;
  body: string;
}

export function parseWhatsAppAgentPrefix(content: string): ParsedAgentPrefix {
  const match = content.match(/^\*([^*\r\n]+)\*\s*\r?\n\r?\n([\s\S]*)$/);
  if (match) {
    return { agentLabel: match[1].trim(), body: match[2] };
  }
  return { agentLabel: null, body: content };
}

export function getMessageBubbleDisplayParts(message: WhatsAppMessage): {
  header: string | null;
  body: string;
} {
  if (message.direction !== "OUTBOUND") {
    return { header: null, body: message.content };
  }
  if (message.type === "TEXT") {
    const parsed = parseWhatsAppAgentPrefix(message.content);
    const header = message.user?.name ?? parsed.agentLabel ?? null;
    const body = parsed.agentLabel !== null ? parsed.body : message.content;
    return { header, body };
  }
  return {
    header: message.user?.name ?? null,
    body: message.content,
  };
}

export function buildOutboundTextPayload(operatorName: string, messageBody: string): string {
  const trimmedName = operatorName.trim();
  const trimmedBody = messageBody.trim();
  if (!trimmedName) {
    return trimmedBody;
  }
  return `*${trimmedName}*\n\n${trimmedBody}`;
}
